export const LANGUAGES = {
	EN: 'en',
};